import { EVENT_STATS } from 'queries/stats';
import { makeApolloClient, logError } from '../util';
import { FETCH_EVENT_STATS } from './actionTypes';

const fetchEventStats = (stats, from = '') => ({
	type: FETCH_EVENT_STATS,
	from,
	stats,
});

export const thunkFetchEventStats = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { stats } = await client.request(EVENT_STATS, {
			event_id: eventID,
		});
		dispatch(fetchEventStats(stats, from));
	} catch (error) {
		logError(error, 'stats.actions.thunkFetchEventStats');
	}
};
